export enum UIMode {
    Light = 'light',
    Dark = 'dark'
}
  
export enum UITheme {
    Orange = 'orange',
    Blue = 'blue',
    Red = 'red'
}
  
export enum NavBarState {
    Expanded = 'expanded',
    Collapsed = 'collapsed',
}

export interface UISettings{
    mode:UIMode,
    theme:UITheme
}